export const contextMenuInitialState = {
  isVisible: false,
  xOffset: 0,
  yOffset: 0,
};
